module.exports = __webpack_public_path__ + "img/konfigurasi_komisi.7da0571c.svg";